/*
 *
 * RefoundBackbookISP
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import './RefoundBackbookISP.scss'

const RefoundBackbookISP = (props) => {
  const navigate = useNavigate()

  const { userType } = props
  const isUserTypeAllowed = (userType) => userType === 'MIXED_ISP_ADMIN' || userType === 'MIXED_ISP_SECONDARY_OR_OPERATIVE'

  const messageMap = {
    title: isUserTypeAllowed(userType) ? formattedMessage[userType].title : '',
    description: isUserTypeAllowed(userType) ? formattedMessage[userType].description : '',
    primaryButtonLabel: isUserTypeAllowed(userType) ? formattedMessage[userType].primaryButtonLabel : '',
    secondaryButtonLabel: isUserTypeAllowed(userType) ? formattedMessage[userType].secondaryButtonLabel : ''
  }

  const onClose = () => {
    props.actions.doHideTtl()
    props.actions.doRetrieveTTL()
  }

  const handlePrimaryButtonAction = () => {
    props.actions.doHideTtl()
    navigate('profile/personal-data')
  }

  return (
    <Toggle>
      {userType === 'MIXED_ISP_ADMIN' && (
        <MerchantModal
          title={messageMap.title}
          description={messageMap.description}
          onClose={() => onClose()}
          primaryButtonLabel={messageMap.primaryButtonLabel}
          primaryAction={() => handlePrimaryButtonAction()}
          secondaryButtonLabel={messageMap.secondaryButtonLabel}
          secondaryAction={() => onClose()}
        />
      )}
      {userType === 'MIXED_ISP_SECONDARY_OR_OPERATIVE' && (
        <MerchantModal
          title={messageMap.title}
          description={messageMap.description}
          onClose={() => onClose()}
          primaryButtonLabel={messageMap.primaryButtonLabel}
          primaryAction={() => onClose()}
        />
      )}

    </Toggle>
  )
}

RefoundBackbookISP.propTypes = {
  actions: PropTypes.object,
  userType: PropTypes.string
}

RefoundBackbookISP.defaultProps = {
  actions: {},
  userType: ''
}

export default RefoundBackbookISP
